import { z } from 'zod';
const policyProposalsSummarySchema = z.object({
    pendingCount: z.number().int(),
    discoveredRuleCount: z.number().int(),
    proposedAdrCount: z.number().int(),
    proposedCodingStandardCount: z.number().int(),
    patternProposalCount: z.number().int(),
});
export const rulesInsightsDriftHotspotSchema = z.object({
    concernKey: z.string(),
    title: z.string(),
    confidence: z.number(),
    affectedRepositoryCount: z.number().int(),
    linkedProposalId: z.string().uuid().nullable().optional(),
});
export const rulesInsightsMissingDecisionSchema = z.object({
    concernKey: z.string(),
    title: z.string(),
    confidence: z.number(),
    linkedProposalId: z.string().uuid().nullable().optional(),
});
export const rulesInsightsSummaryBundleSchema = z.object({
    snapshotAt: z.string().datetime(),
    standardsCoverage: z.object({
        acceptedStandardsCount: z.number().int(),
        acceptedAdrsCount: z.number().int(),
        repositoriesWithDiscoveryCount: z.number().int(),
        coveragePercent: z.number().nullable().optional(),
    }),
    pendingProposals: policyProposalsSummarySchema,
    driftHotspots: z.array(rulesInsightsDriftHotspotSchema),
    missingDecisions: z.array(rulesInsightsMissingDecisionSchema),
    acceptanceRate30d: z.number().nullable(),
});
export const detectedPracticeItemSchema = z.object({
    label: z.string(),
    confidence: z.number(),
    sourcePath: z.string(),
    linkedProposalId: z.string().uuid().nullable().optional(),
});
export const detectedPracticesSectionSchema = z.object({
    title: z.string(),
    lastScanAt: z.string().datetime().nullable().optional(),
    items: z.array(detectedPracticeItemSchema),
});
export const onboardingBriefSectionSchema = z.object({
    key: z.enum(['accepted_standards', 'active_adrs', 'known_patterns', 'top_review_themes']),
    title: z.string(),
    items: z.array(z.object({
        label: z.string(),
        excerpt: z.string().nullable().optional(),
        deepLink: z.string(),
    })),
});
export const onboardingBriefBundleSchema = z.object({
    generatedAt: z.string().datetime(),
    expiresAt: z.string().datetime(),
    sections: z.array(onboardingBriefSectionSchema),
});
//# sourceMappingURL=rules-insights.schemas.js.map